/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
// Copyright 2021 channysok
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
//     http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import WaybillAction from "../action/WaybillAction"

export const initialState = ({
    loading: false,
    waybillList: null, 
    waybillArrivedList: null, 
    waybill: null,   
})

const insert = (arr, index, item) =>
  arr.reduce(function(s, a, i) {
    i === index ? s.push(item, a) : s.push(a);
    return s;
  }, []); 

export default function (state = initialState, action) {
    switch (action.type) {
  
      case WaybillAction.TYPES.REQUEST_WAYBILL_LIST:
        return Object.assign({}, state, { waybillList: null, loading: true})
  
      case WaybillAction.TYPES.REQUEST_WAYBILL_LIST_SUCCESS:
        return Object.assign({}, state, { waybillList: action.payload, loading: false})

      case WaybillAction.TYPES.REQUEST_WAYBILL_ARRIVED_LIST_SUCCESS:
        return Object.assign({}, state, { waybillArrivedList: action.payload, loading: false})

      case WaybillAction.TYPES.REQUEST_DETAIL_WAYBILL_SUCCESS:
        return Object.assign({}, state, { waybill: action.payload.data, loading: false})

      case WaybillAction.TYPES.CLEAR_WAYBILL:
        return Object.assign({}, state, { waybill: undefined, loading: false})
  
      case WaybillAction.TYPES.REQUEST_UPDATE_WAYBILL_SUCCESS: {
        const newList = state.waybillList
        if(newList == null || newList == undefined) return Object.assign({}, state, {loading: false});
        newList.data = newList.data.map(item => {
          if(item.id == action.payload.data.id) {
            return action.payload.data
          }
          return item
        })
        return Object.assign({}, state, { waybillList: newList, loading: false})
      }  

      case WaybillAction.TYPES.REQUEST_UPDATE_WAYBILL_ARRIVED_SUCCESS: {
        const newList = state.waybillArrivedList
        if(newList == null || newList == undefined) return Object.assign({}, state, {loading: false});
        newList.data = newList.data.map(item => {
          if(item.id == action.payload.data.id) {
            return action.payload.data
          }
          return item
        })
        return Object.assign({}, state, { waybillArrivedList: newList, loading: false})
      }
      
      
      case WaybillAction.TYPES.REQUEST_DELETE_WAYBILL_SUCCESS: {
        const newList = state.waybillList
        if(newList == null || newList == undefined) return Object.assign({}, state, {loading: false});
        newList.data = newList.data.filter(item => {
          if(item.id != action.payload.data.id) {
            return item
          }          
        })
        return Object.assign({}, state, { waybillList: newList, loading: false})
      }  
      
      case WaybillAction.TYPES.REQUEST_CREATE_WAYBILL_SUCCESS_1: {
        const newList = state.waybillList      
        if(newList == null || newList == undefined) return Object.assign({}, state, {loading: false});        
        newList.data = [action.payload.data, ...newList.data]
        return Object.assign({}, state, { waybillList: newList, loading: false})
      }  
      
      
      default:
        return state
    }
}



  